import { render, staticRenderFns } from "./T1.vue?vue&type=template&id=6a24f152&scoped=true&"
import script from "./T1.vue?vue&type=script&lang=js&"
export * from "./T1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24f152",
  null
  
)

export default component.exports